import { t as e } from "../utils-DiFe-_ei.js";
import * as t from "react";
import { jsx as n } from "react/jsx-runtime";
//#region src/foundations/table/table.tsx
var r = t.forwardRef(({ className: t, ...r }, i) => /* @__PURE__ */ n("div", {
	className: "relative w-full overflow-auto",
	children: /* @__PURE__ */ n("table", {
		ref: i,
		className: e("w-full caption-bottom text-sm", t),
		...r
	})
}));
r.displayName = "Table";
var i = t.forwardRef(({ className: t, ...r }, i) => /* @__PURE__ */ n("thead", {
	ref: i,
	className: e("[&_tr]:border-b", t),
	...r
}));
i.displayName = "TableHeader";
var a = t.forwardRef(({ className: t, ...r }, i) => /* @__PURE__ */ n("tbody", {
	ref: i,
	className: e("[&_tr:last-child]:border-0", t),
	...r
}));
a.displayName = "TableBody";
var o = t.forwardRef(({ className: t, ...r }, i) => /* @__PURE__ */ n("tfoot", {
	ref: i,
	className: e("border-t bg-muted/50 font-medium [&>tr]:last:border-b-0", t),
	...r
}));
o.displayName = "TableFooter";
var s = t.forwardRef(({ className: t, ...r }, i) => /* @__PURE__ */ n("tr", {
	ref: i,
	className: e("border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted", t),
	...r
}));
s.displayName = "TableRow";
var c = t.forwardRef(({ className: t, ...r }, i) => /* @__PURE__ */ n("th", {
	ref: i,
	className: e("h-12 px-4 text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0", t),
	...r
}));
c.displayName = "TableHead";
var l = t.forwardRef(({ className: t, ...r }, i) => /* @__PURE__ */ n("td", {
	ref: i,
	className: e("p-4 align-middle [&:has([role=checkbox])]:pr-0", t),
	...r
}));
l.displayName = "TableCell";
var u = t.forwardRef(({ className: t, ...r }, i) => /* @__PURE__ */ n("caption", {
	ref: i,
	className: e("mt-4 text-sm text-muted-foreground", t),
	...r
}));
u.displayName = "TableCaption";
//#endregion
export { r as Table, a as TableBody, u as TableCaption, l as TableCell, o as TableFooter, c as TableHead, i as TableHeader, s as TableRow };

//# sourceMappingURL=table.js.map